"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var Payloads_1 = require("../../../../../../../packages/ui-shared-lite/Payloads");
var InlineFeedback_1 = require("./InlineFeedback");
var Message_1 = __importDefault(require("./Message"));
var MessageGroup = /** @class */ (function (_super) {
    __extends(MessageGroup, _super);
    function MessageGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
            audioPlayingIndex: 0
        };
        /**
         * @deprecated 12.0
         * Here, we convert old format to the new format Botpress uses internally.
         * - payload: all the data (raw, whatever) that is necessary to display the element
         * - type: extracted from payload for easy sorting
         */
        _this.convertPayloadFromOldFormat = function (data) {
            var _a, _b, _c;
            var payload = data.payload || data.message_data || data.message_raw || { text: data.message_text };
            if (!payload.type) {
                payload.type = data.message_type || ((_a = data.message_data) === null || _a === void 0 ? void 0 : _a.type) || 'text';
            }
            // Keeping compatibility with old schema for the quick reply
            if (data.message_type === 'quick_reply' && !payload.text) {
                payload.text = data.message_text;
            }
            if (data.message_type === 'file' && !payload.url) {
                payload.url = ((_b = data.message_data) === null || _b === void 0 ? void 0 : _b.url) || ((_c = data.message_raw) === null || _c === void 0 ? void 0 : _c.url);
            }
            if (_this.props.messageWrapper && payload.type !== 'session_reset') {
                payload = {
                    type: 'custom',
                    module: _this.props.messageWrapper.module,
                    component: _this.props.messageWrapper.component,
                    wrapped: payload
                };
            }
            return payload;
        };
        _this.onAudioEnded = function () {
            if (_this.state.audioPlayingIndex >= _this.props.messages.length - 1) {
                _this.state.audioPlayingIndex = -1;
            }
            else {
                _this.setState(__assign(__assign({}, _this.state), { audioPlayingIndex: _this.state.audioPlayingIndex += 1 }));
            }
        };
        return _this;
    }
    MessageGroup.getDerivedStateFromError = function (_error) {
        return { hasError: true };
    };
    MessageGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, messages = _a.messages, avatar = _a.avatar, isBot = _a.isBot, showUserName = _a.showUserName, userName = _a.userName;
        var fromLabel = this.props.store.intl.formatMessage({
            id: this.props.isBot ? 'message.fromBotLabel' : 'message.fromMeLabel',
            defaultMessage: 'Me'
        });
        if (this.state.hasError) {
            return '* Cannot display message *';
        }
        return (react_1.default.createElement("div", { role: "main", className: (0, classnames_1.default)('bpw-message-big-container', {
                'bpw-from-user': !isBot,
                'bpw-from-bot': isBot
            }) },
            avatar,
            react_1.default.createElement("div", { role: "region", className: 'bpw-message-container' },
                showUserName && react_1.default.createElement("div", { className: 'bpw-message-username' }, userName),
                react_1.default.createElement("div", { "aria-live": "assertive", role: "log", className: 'bpw-message-group' },
                    react_1.default.createElement("span", { "data-from": fromLabel, className: "from hidden", "aria-hidden": "true" }, fromLabel),
                    (0, sortBy_1.default)(messages, ['sentOn', 'eventId']).map(function (message, i, messages) {
                        var payload = _this.convertPayloadFromOldFormat(message);
                        if (payload.wrapped) {
                            payload = __assign(__assign({}, payload), { wrapped: (0, Payloads_1.renderPayload)(payload.wrapped) });
                        }
                        else {
                            payload = (0, Payloads_1.renderPayload)(payload);
                        }
                        var showInlineFeedback = isBot && (payload.wrapped ? payload.wrapped.collectFeedback : payload.collectFeedback);
                        return (react_1.default.createElement(Message_1.default, { key: message.id, isHighlighted: _this.props.highlightedMessages && _this.props.highlightedMessages.includes(message.id), inlineFeedback: showInlineFeedback && (react_1.default.createElement(InlineFeedback_1.InlineFeedback, { intl: _this.props.store.intl, messageId: message.id, onFeedback: _this.props.onFeedback, messageFeedbacks: _this.props.store.messageFeedbacks })), messageId: message.id, noBubble: !!payload.noBubble, fromLabel: fromLabel, isLastOfGroup: i >= _this.props.messages.length - 1, isLastGroup: _this.props.isLastGroup, isBotMessage: !message.authorId, payload: payload, sentOn: message.sentOn, onSendData: _this.props.onSendData, onFileUpload: _this.props.onFileUpload, bp: _this.props.bp, store: _this.props.store, onAudioEnded: _this.onAudioEnded, shouldPlay: _this.state.audioPlayingIndex === i }));
                    })))));
    };
    return MessageGroup;
}(react_1.default.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        store: store,
        bp: store.bp,
        onFeedback: store.sendFeedback,
        onSendData: store.sendData,
        onFileUpload: store.uploadFile,
        messageWrapper: store.messageWrapper,
        showUserName: store.config.showUserName,
        highlightedMessages: store.view.highlightedMessages
    });
})(MessageGroup);
